export default {
    pageTitle: 'بازی شوت شات',
    pageActions: [],
    defaultActions: [
        {icon: 'mdi-menu', path: 'sidebar'},
    ],
    hasNavigation: false,
    api: {
        url: 'https://shootshot.com/api/',
        headers: {
            //'Accept': "application/json",
            'Content-type': "multipart/form-data",
        },
        timeout: 25000,
    },
    token: null,
    loginRedirectPath: null,
    userData: {},
    showSidebar: false,
    apiCache: {},
    settings: null,
}